'use client';

/**
 * Whether the root banner asks this person to agree to the firm's move
 * (ruling 1: agreement by email and by a banner at next sign-in; research 01
 * §2.4.3).
 *
 * ONLY THE FIRM'S OWN ADMINISTRATOR OF A LEGACY FIRM ASKS THE SERVER. The
 * identity already carries `isOrgAdmin` and `bookMode` (package A), so a
 * member, a super-admin acting inside the firm, and a firm on the book read
 * nothing, and nor does a firm with Cova CRM off. The status read itself is
 * cheap (no matcher) and fresh for five minutes.
 */
import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { AGREEMENT_PAGE_PATH } from '@/contexts/bms/cutover/agreement/domain/move-request-email';
import { isSwitchOn } from '@/contexts/bms/shared/domain/firm-switches';
import { useIdentity } from '@/lib/providers/identity';
import { NO_ORG, cutoverStatusQueryOptions } from './api/cutover-agreement';
export function useCutoverBanner() {
  const $ = _c(13);
  const {
    identity
  } = useIdentity();
  const pathname = usePathname();
  const organizationId = identity?.orgId ?? null;
  let t0;
  if ($[0] !== identity || $[1] !== organizationId) {
    t0 = organizationId !== null && identity?.isOrgAdmin === true && identity.bookMode === "legacy" && isSwitchOn(identity.firmSwitches, "crm");
    $[0] = identity;
    $[1] = organizationId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const asks = t0;
  const t1 = organizationId ?? NO_ORG;
  let t2;
  if ($[3] !== t1) {
    t2 = cutoverStatusQueryOptions(t1);
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== asks || $[6] !== t2) {
    t3 = {
      ...t2,
      enabled: asks,
      retry: false
    };
    $[5] = asks;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data
  } = useQuery(t3);
  let t4;
  if ($[8] !== pathname) {
    t4 = pathname?.startsWith(AGREEMENT_PAGE_PATH);
    $[8] = pathname;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const onPage = t4 === true;
  const t5 = asks && data?.awaitingAgreement === true && !onPage;
  const t6 = identity?.orgName ?? null;
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = {
      shown: t5,
      orgName: t6
    };
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7 as const;
}